<template>
  <div class="img_upload">
    <el-upload ref="imgref" list-type="picture-card" :action="uploadUrl" multiple :headers="upHeader" :limit="6" :on-exceed="maxImg" accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG" :before-upload="beforeUpload" :on-success="upImg" :on-remove="RemoveImg">

      <i class="el-icon-plus" v-show="addShow"></i>
      <!-- <div v-show="addShow">将文件拖到此处，或<em>点击上传</em></div> -->

      <div class="max_img" v-show="!addShow"> <i class="el-icon-warning"></i>最多只能上传6张图片！</div>
    </el-upload>
    <div>只能上传jpg/png文件，且不超过5Mb，最多只能上传6张！</div>
  </div>
</template>

<script>
export default {
  name: "Upimg",
  props: {
    // imgurl: Object,  //父向子传值
  },

  data: function () {
    return {
      uploadUrl: this.common.uploadUrl(), //图片上传路径
      //  uploadUrl: "http://localhost:8080/api/file/uploadFile", //图片上传路径
      // 请求头参数
      upHeader: {
        operator: JSON.parse(sessionStorage.getItem("user")).userAccount,
      },
      addShow: true,
      sameFlag: true,
      localNameList: [], //本地图片名称列表
      upNameList: [], //上传后图片的名称
    };
  },

  methods: {
    // 上传前 文件检验
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      let typeFlag = false; //类型标记
      this.sameFlag = true; //相同标记
      const isLt2M = file.size / 1024 / 1024 < 5; //限制大小
      let picType = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]; //允许上传的类型
      // 图片后缀检验
      for (let i = 0; i < picType.length; i++) {
        if (testmsg == picType[i]) {
          typeFlag = true;
          break;
        }
      }
      if (!typeFlag) {
        this.$message({
          message: "请上传jpg、jpeg或png格式的图片！",
          type: "warning",
        });
      }
      // 图片大小检验
      if (!isLt2M) {
        this.$message({
          message: "上传图片大小不能超过 5MB!",
          type: "warning",
        });
      }
      // 改为手动上传后   失效
      // 重复图片检验
      for (let i = 0; i < this.localNameList.length; i++) {
        if (file.name == this.localNameList[i]) {
          this.sameFlag = false;
          this.$message({
            message: "请勿重复上传同一照片！",
            type: "warning",
          });
          break;
        }
      }
      return typeFlag && isLt2M && this.sameFlag;
    },

    maxImg(files, fileList) {
      this.addShow = false;
      this.$message({
        message: "最多只能上传6张图片！",
        type: "warning",
      });
    },

    // 上传图片成功
    upImg(res, file) {
      this.localNameList.push(file.name); //将本地图片名存入列表，用于重复文件上传检验
      // 将路径中的图片名提取出来并存储起来 用于存入数据库
      this.upNameList.push(res.data); //上传后图片名称列表
      // 上限提示
      if (this.upNameList.length >= 6) {
        this.addShow = false;
      } else {
        this.addShow = true;
      }
      // 上传成功后将图片名数组传向父组件
      this.$emit("imglist", this.upNameList);
    },

    // 清空图片显示
    clearImgs() {
      this.$refs.imgref.clearFiles();
      this.localNameList = [];
      this.upNameList = [];
      this.addShow = true;
      this.$emit("imglist", this.upNameList);
    },

    //重置表单删除图片
    clearForms() {
      // 先删除上传的图片
      this.$Loading.show();
      let pardata = {
        fileList: this.upNameList.toString(),
      };
      this.http.From("/file/deleteFile", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          // 清空图片显示
          this.$refs.imgref.clearFiles();
          this.localNameList = [];
          this.upNameList = [];
          this.addShow = true;
          // 将图片名数组传向父组件
          this.$emit("imglist", this.upNameList);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //删除图片
    async RemoveImg(file) {
      if (!this.sameFlag) {
        this.sameFlag = true;
        return;
      }

      let index = this.localNameList.indexOf(file.name); //寻找删除图片名称在数组中的位置，
      // this.$Loading.show();
      let pardata = {
        fileList: this.upNameList[index],
      };
      this.http.From("/file/deleteFile", pardata).then((res) => {
        // this.$Loading.hide();
        if (res.code == "0") {
          this.localNameList.splice(index, 1);
          this.upNameList.splice(index, 1);
          this.addShow = true;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.$emit("imglist", this.upNameList); // 将图片名数组传向父组件
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.img_upload {
  .max_img {
    line-height: 12rem;
    font-size: $f-big;
    color: $c-error;
    i {
      margin-right: $m-lit;
    }
  }
}
</style>